export class TokenCounter {
    id = 0;
    promptAmount = 0;
    completionAmount = 0;
    embeddingAmount = 0;
    date = new Date();

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.promptAmount = data.prompt_amount ?? 0;
        this.completionAmount = data.completion_amount ?? 0;
        this.embeddingAmount = data.embedding_amount ?? 0;
        this.date = data.date !== null ? new Date(data.date) : new Date();

        return this;
    }
}
